<template>
    <transition name="modal">  
        <!-- The Modal -->
        <div class="modal-mask">
            <div class="modal-wrapper">
                <div class="modal-dialog modal-dialog-scrollable">
                    <div class="modal-content rounded-8">

                        <!-- Modal Header -->
                        <div class="modal-header bg-utel-v2-secondary text-primary">
                            <h4 class="modal-title"><strong>Editar información</strong></h4>
                            <button type="button" @click="close" class="btn btn-close bg-utel-v2-secondary text-primary close" data-dismiss="modal">×</button>
                        </div>
                        
                        <!-- Modal body -->
                        <div class="modal-body">
                            <div class="row col-12">
                                <small>Cambia los campos... y guarda.</small>
                            </div>
                            <div class="row col-12">
                                <small for="">Nombre de la licencia</small>
                                <input type="text" class="rounded-8 form-control sin-borde text-primary"
                                    v-model="editPlan.name" placeholder="Nombre de la licencia">
                            </div>
                            <div class="row col-12">
                                <small for="">Número de usuarios disponibles</small>
                                <input type="number" class="rounded-8 form-control sin-borde text-primary"
                                    v-model="editPlan.accepted_users" placeholder="Número de usuarios disponibles">
                            </div>
                            <div class="row col-12">
                                <small for="">Número de rutas disponibles</small>
                                <input type="number" class="rounded-8 form-control sin-borde text-primary"
                                    v-model="editPlan.accepted_routes" placeholder="Número de rutas disponibles">
                            </div>
                            <div class="row col-12">
                                <small for="">Número total de cursos</small>
                                <input type="number" class="rounded-8 form-control sin-borde text-primary"
                                    v-model="editPlan.accepted_courses" placeholder="Número total de cursos">
                            </div>
                            <div class="row col-12">
                                <small for="">Número total de cursos</small>
                                <input type="number" class="rounded-8 form-control sin-borde text-primary"
                                    v-model="editPlan.accepted_courses" placeholder="Número total de cursos">
                            </div>
                            <div class="row col-12">
                                <small for="">Tiempo de licencia</small>
                                <input type="number" class="rounded-8 form-control sin-borde text-primary"
                                    v-model="editPlan.expiration_day" placeholder="Tiempo de licencia">
                            </div>
                            <div class="row col-12">
                                <small for="">Tipo de tiempo</small>
                                <select v-model="editPlan.expiration_type" class="form-control sin-borde rounded-8 text-primary">
                                    <option value="" selected="selected" disabled>Seleccione el tipo de tiempo</option>
                                    <option value="hours">Horas</option>
                                    <option value="days">Días</option>
                                    <option value="month">Meses</option>
                                    <option value="years">Años</option>
                                </select>
                            </div>
                        </div>
                        
                        <!-- Modal footer -->
                        <div class="modal-footer">
                            <button type="button" class="btn text-primary bg-utel-v2-secondary mx-3 sin-borde" @click="close"
                                aria-label="Close modal">
                                Cancelar
                            </button>
                            <button type="button" id="update-button" class="btn text-white bg-utel" @click="updatePlan"
                                aria-label="Eliminar usuario">
                                Guardar cambios
                            </button>                           
                        </div>
                        
                    </div>
                </div>
            </div>
        </div>        
    </transition>
</template>
<script>
import axios from 'axios';

    export default {
        props: ['get', 'plan'],
        data(){
            return {
                editPlan: { ...this.plan },
                error: [],
                urlEditPlan: `${ this.get }/${ this.plan.id }`
            }
        },
        methods: {
            close() {
                this.$emit('close');
            },
            updatePlan(){
                const context = this;
                const submitButton = document.getElementById('update-button');
                submitButton.setAttribute('disabled', 'disabled');
                submitButton.textContent = 'Procesando...';
                axios.put(this.urlEditPlan, this.editPlan)
                .then(( res ) => {
                    submitButton.removeAttribute('disabled');
                    submitButton.textcontent = 'Guardar cambios';
                    context.$emit('reloadtable', true);
                    context.close();
                })
                .catch( err => {
                    if ( !err.response ) return;

                    submitButton.removeAttribute('disabled');
                    submitButton.textcontent = 'Guardar cambios';
                })
            }
        }
    }
</script>
<style>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  /*display: table;*/
  transition: opacity .3s ease;
}

.modal-wrapper {
  /*display: table-cell;*/
  vertical-align: middle;
}
</style>
